import React from 'react';
import './styles.scss';
import axios from 'axios';
import CommonConstants from '../../utils/CommonConstants';
import BFMHeader from './BFMHeader';
import { stepFillOut, stepConfirmation, stepSuccess } from './constants';
import HowItWorks from './HowItWorks';
import {history} from '../../store';
// import ItemFormInput from './ItemFormInput';
import { renderHTML } from './utils';
import TNCModal from './TNCModal';
// import { Link } from 'react-router';
import GetStarted from './GetStarted';

const apiUrl = CommonConstants.Actions.api;
const createReactClass = require('create-react-class');
let arrayString = [];

const BuyForMe = createReactClass({
  getInitialState: function () {
    return {
      showModal: false,
      activeStepIndicator: stepFillOut,
      formStatus: 'fillOut',
      form: {
        emailAddress: '',
        accountNumber: '',
        origin: '',
        shippingMethod: 'None',
        items: [
          {
            itemName: '',
            websiteLink: '',
            quantity: '',
            size: '',
            color: '',
            others: '',
            image: '',
          }
        ]
      },
      images: [],
      error: false,
      successData: null,
      closedModal: false,
      emailErrorMsg: '',
      errorUpload: [],
    }
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.login.login && nextProps.login.login.party && !this.state.form.accountNumber) {
      const defaultEmail = nextProps.login.login.party.email;
      const defaultAccountNumber = nextProps.login.login.party.account_number;
      const defaultForm = { ...this.state.form, ...{ emailAddress: defaultEmail, accountNumber: defaultAccountNumber } }
      this.setState({
        form: defaultForm
      })
    }
  },

  handleInputChange(e, index) {
    const name = e.target.name
    const value = e.target.value

    const formCopy = {...this.state.form};
    const currentInput = {[name]: value};

    if (name === 'origin' && (value !== 'JP' && value !== 'KR')) {
      const formCopy = { ...this.state.form };
      formCopy.items.forEach(item => {
        item.image = ''
      })
      this.setState({ form: formCopy });
      this.setState({ images: [] })
    }

    if (name === 'quantity' && value) {
      const re = /^[0-9.\b]+$/;
      if (!re.test(e.target.value)) return
      if (value < 1) return;
    }

    if (index !== undefined) {
      formCopy.items[index] = {...formCopy.items[index], ...currentInput}
      this.setState({form: formCopy})
      return;
    }
    const currentForm = {...this.state.form,...currentInput}
    this.setState({form: currentForm})
  },

  handleRemoveItem(index) {
    const formCopy = {...this.state.form}
    formCopy.items.splice(index, 1);
    this.setState({form: formCopy})

    const imageList = this.state.images;
    const imageKey = imageList.findIndex((obj) => obj.key === index);
    imageList.splice(imageKey, 1);
    this.setState({ images: imageList });
  },

  renderButtons() {
    if (this.state.successData && this.state.successData.ticket) return;

    if (this.state.formStatus === 'fillOut') {
      return ( 
      <div className='bfm-form-buttons'>
        <button className='bfm-button' onClick={this.handleAddItem}>Add Item</button>
          <button className='bfm-button' style={{ backgroundColor: '#AA0E0E', color: '#fff' }} onClick={this.handleReview}>PROCEED</button>
      </div>
    )
    }
    if (this.state.formStatus === 'confirmation') {
      return ( 
      <div className='bfm-form-buttons'>
        <button className='bfm-button' onClick={() => {this.resetForm()}}
        >Cancel</button>
        <button className='bfm-button' style={{ backgroundColor: '#AA0E0E', color: '#fff' }} onClick={this.handleSubmit}> Submit</button>
      </div>
      )
    }

  },

  handleAddItem() {
    const formCopy = {...this.state.form}
    formCopy.items.push({
        itemName: '',
        websiteLink: '',
        quantity: '',
        size: '',
        color: '',
        others: '',
        image: '',
    })

    this.setState({ form: {...formCopy} })
  },

  handleShowTNCModal() {
    this.setState({
      showModal: true,
      closedModal: false,
    })
  },

  handleCloseModal() {
    this.setState({
      showModal: false,
      closedModal: true,
    })
  },

  handleReview() {
    window.scrollTo(0, 820)
    this.setState({
      error: false,
      emailErrorMsg: '',
    })
    if (this.checkForErrors(this.state.form)) {
      this.setState({error: true})
      return
    }
    this.handleShowTNCModal();
       
  },

  handleContinue() {
    window.scrollTo(0, 220);
    this.setState({
      formStatus: 'confirmation',
      activeStepIndicator: stepConfirmation,
      showModal: false
    })
  },

  handleSubmit() {
    this.convertObjectToString(this.state.form)
    if (this.state.images) {
      const data = new FormData();
      const images = this.state.images.length;
      for (let x = 0; x < images; x++) {
        data.append("images[]", this.state.images[x]);
      }
      data.append("subject", `SC Buy for ${this.state.form.emailAddress}`);
      data.append("details", renderHTML(this.state.form));
      data.append("assignee_email", 'customercare@shippingcart.com');
      data.append("requester", this.state.form.emailAddress);

      axios({
        url: apiUrl + 'users/create/support-ticket',
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data
      }).then((res) => {
        this.setState({ successData: res.data })
        arrayString = [];
        window.scrollTo(0, 820)
      })
    } else {
      axios.post(apiUrl + 'users/create/support-ticket', {
        data: {
          subject: `SC Buy for ${this.state.form.emailAddress}`,
          details: renderHTML(this.state.form),
          assignee_email: 'customercare@shippingcart.com',
          requester: this.state.form.emailAddress
        }
      }).then((res) => {
        this.setState({ successData: res.data })
        arrayString = [];
        window.scrollTo(0, 820)
      })
    }
  },

  resetForm() {
    this.setState({
      form: {
      emailAddress: this.props.login.login.party && this.props.login.login.party.email,
      accountNumber: this.props.login.login.party && this.props.login.login.party.account_number,
      origin: '',
      items: [
        {
          itemName: '',
          websiteLink: '',
          quantity: '',
          size: '',
          color: '',
          others: '',
          image: '',
        }
      ]
    },
    formStatus: 'fillOut',
    activeStepIndicator: stepFillOut,
    emailErrorMsg: '',
    images: [],
   })
  },

  checkImageAndLink (item) {
    if (item.image) { 
      return 'link';
    }
    return 'image';
  },

  checkForErrors(values) {
    if (Object.values(this.state.form).includes('') || this.validateEmail(this.state.form.emailAddress)){ 
      if (this.validateEmail(this.state.form.emailAddress)) this.setState({ emailErrorMsg: 'Please enter a valid email address.' });
      return true;
    } 
    let currentValue = false;
    this.state.form.items.forEach((item) => {
      if (item.image || item.link) { return true}
      const filterItem = Object.keys(item).filter(key =>
        key !== 'others' && key !== this.checkImageAndLink(item)).reduce((obj, key) => {
          obj[key] = item[key];
          return obj;
        }, {}
        );
      if (Object.values(filterItem).includes('')) {
        currentValue=true
      }; 
    })
    return currentValue
  },

  convertObjectToString(obj) {
    Object.entries(obj).every((item) => {
      if (item[1] instanceof Array) {
        item[1].forEach((itemDetail) => {
          this.convertObjectToString(itemDetail)
          return false;
        })
      } else {
        arrayString.push(`${item[0].replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })}: ${item[1]}`)
        return true;
      }
      return true;
    })
  },

  validateEmail(email) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) return true
  },

  onDrop (accepted, rejected, index) {
    let error = null;
    const maxAllowedSize = 5120;
    const fileSizeKiloBytes = accepted[0] && accepted[0].size / 1024;

    if (rejected.length > 0) {
      error = "Invalid file format"
    }
    if (accepted && fileSizeKiloBytes > maxAllowedSize) {
      error = "File can't be uploaded because it exceeded the maximum file size (5MB)"
    }

    if (error) {
      const itemNumber = { error: error, key: index }
      const copyErrorUpdload = this.state.errorUpload;
      const errorKey = this.state.errorUpload.findIndex((obj) => obj.key === index);
      if (errorKey !== -1) {
        copyErrorUpdload.splice(errorKey, 1);
      }
      copyErrorUpdload.push(itemNumber)
      this.setState({ errorUpload: copyErrorUpdload })
    } else {
      const errorKey = this.state.errorUpload.findIndex((obj) => obj.key === index);
      this.state.errorUpload.splice(errorKey, 1);
      this.setState({ errorUpload: this.state.errorUpload })

      const imageName = `Item ${index+1}`;
      const renamedAcceptedFiles = accepted.map((file) => {
        const changedFileName = new File([file], imageName, { type: file.type });
        changedFileName.preview = accepted[0].preview;
        changedFileName.key = index;
        return changedFileName;
      })

      this.state.images.push(renamedAcceptedFiles[0])
      this.setState({ images: this.state.images })

      const formCopy = { ...this.state.form };
      const currentInput = { image: renamedAcceptedFiles[0] };
      formCopy.items[index] = { ...formCopy.items[index], ...currentInput }
      this.setState({ form: formCopy });
    }
  },

  handleDeleteImage (index) {
    const imageList = this.state.images
    const imageKey = imageList.findIndex((obj) => obj.key === index);
    imageList.splice(imageKey, 1);
    this.setState({ images: imageList })

    const formCopy = { ...this.state.form };
    const currentInput = { image: '' };
    formCopy.items[index] = { ...formCopy.items[index], ...currentInput }
    this.setState({ form: formCopy });
  },


  render() {
    // const checkLoggedIn = this.props.login.login && this.props.login.login.party;
    return (
      <div className='bfm-wrapper'>
        <BFMHeader />
        <div className='bfm-content'>
          <HowItWorks />
          <GetStarted />
          {
            (this.state.successData) ? 
            <div className='bfm-fill-it-out-1' style={{ backgroundColor: 'white' }}>
              <p className='bfm-section-header'>SUCCESS</p>
              <div className='bfm-steps-indicator'>
                  { stepSuccess.map(({ icon, text, isActive }) => (
                    <div className='bfm-step-item'>
                      <div>
                        <img src={icon} alt='icon' /> 
                      </div>
                      <p className='bfm-step-item-text' style={isActive ? { borderTop: '4px solid #0258A3', color: '#707070' }: {}}>{text}</p>
                    </div>
                  )) }
                </div>
                <div className='flex-center'>
                  <div style={{ width: 343, textAlign: 'center' }}>
                    <p style={{ fontSize: 20, fontWeight: 600 }}>Request submitted!</p>
                    <p>Your reference # is <span style={{ fontWeight: 600 }}>{this.state.successData ? this.state.successData.ticket.id : 'BFM00000'}</span>. Our Customer Care Team will validate the information submitted and you will receive a notification via email within 24 hours.</p>
                    <div className='bfm-form-buttons'>
                      <button className='bfm-button bfm-success-button' onClick={() => { history.push('/') }}>Back to Homepage</button>
                    </div>
                  </div>
                </div>
            </div>
            :
            <div>
              {/* <div className='bfm-fill-it-out-1' style={{ backgroundColor: 'white' }}>
                <p className='bfm-section-header'>FILL OUT THE FORM</p>
                <div className='bfm-steps-indicator'>
                  { this.state.activeStepIndicator.map(({ icon, text, isActive }) => (
                    <div className='bfm-step-item'>
                      <div>
                        <img src={icon} alt='icon' /> 
                      </div>
                      <p className='bfm-step-item-text' style={isActive ? { borderTop: '4px solid #0258A3', color: '#707070' }: {}}>{text}</p>
                    </div>
                  )) }
                </div>
                { !!this.state.error && 
                  <div className='flex-center'>
                    <div className='bfm-error'>
                      Please fill up all required fields.
                    </div>
                  </div> 
                }
                <div className='bfm-form-wrapper'>
                  <div className='bfm-form'>
                    <p className='bfm-form-label'>Customer's email address {this.state.formStatus !== 'confirmation' && <span className='span-required'>*</span>}</p>
                    {this.state.emailErrorMsg ? <span className='input-error'>{this.state.emailErrorMsg}</span> : null}
                    {this.state.formStatus === 'confirmation' ? <p>{this.state.form.emailAddress}</p> : <input placeholder='Enter email address' name="emailAddress" value={this.state.form.emailAddress} onChange={this.handleInputChange} className={this.state.error && (!this.state.form['emailAddress'] || this.validateEmail(this.state.form.emailAddress)) ? "error-input" : ""}/>}
      
                    <p className='bfm-form-label'>Customer’s account number {this.state.formStatus !== 'confirmation' && <span className='span-required'>*</span>}</p>
                    {this.state.formStatus === 'confirmation' ?  <p>{this.state.form.accountNumber}</p> : <input placeholder='Enter account number' name="accountNumber" value={this.state.form.accountNumber} onChange={this.handleInputChange} className={this.state.error && !this.state.form['accountNumber'] ? "error-input" : ""}/>}
      
                    <p className='bfm-form-label'>Which warehouse would the item/s be delivered to? {this.state.formStatus !== 'confirmation' && <span className='span-required'>*</span>}</p>
                      {this.state.formStatus === 'confirmation' ? <p>{this.state.form.origin}</p> : <select type='dropdown' style={{ padding: '0px 0px 0px 10px' }} name="origin" value={this.state.form.origin} onChange={this.handleInputChange} className={`form-control ${this.state.error && !this.state.form['origin'] ? "error-input" : ""}`}>
                      <option value="" disabled selected>Select origin</option>
                      <option value="US">US</option>
                      <option value="UK">UK</option>
                      <option value="AU">AU</option>
                      <option value="KR">KR</option>
                      <option value="JP">JP</option>
                    </select>}

                    <p className='bfm-form-label'>Preferred shipping method</p>
                    {this.state.formStatus === 'confirmation' ? <p>{this.state.form.shippingMethod}</p> : 
                      <div style={{display: 'inline-flex'}}>
                        <div className='shipping-method-wrapper'>
                          <input type="radio" value="Air cargo" name="shippingMethod" id="air" className='shipping-method-button' onChange={this.handleInputChange} />
                          <label htmlFor='air' className='shipping-method-button-label'>Air cargo</label>
                        </div>
                         
                        <div className='shipping-method-wrapper'>
                          <input type="radio" value="Sea cargo" name="shippingMethod" id="sea" className='shipping-method-button' onChange={this.handleInputChange}/> 
                          <label htmlFor='sea' className='shipping-method-button-label'>Sea cargo</label>
                        </div>
                      </div>
                    }

                      {!checkLoggedIn && this.state.formStatus !== 'confirmation' && <p className='bfm-form-label' style={{ marginTop: '10px' }}>Don’t have an account yet? <Link onClick={() => localStorage.setItem("bfmSignup", true)} to="/signup">Sign up here</Link></p>}
                  </div>
                </div>
              </div>
              <div className='bfm-fill-it-out-1'>
                {this.state.formStatus !== 'confirmation' && <div className='flex-center'>
                  <div className='bfm-section-text-wrapper'>
                    <p>Please provide the information needed below so our warehouse can provide a price quote for the item/s</p>
                    <p>** All fields are required</p>
                  </div>
                </div>}
                <div className='bfm-form-wrapper'>
                  <div>
                    <ItemFormInput items={this.state.form.items} error={this.state.error} formStatus={this.state.formStatus} handleInputChange={this.handleInputChange} handleRemoveItem={this.handleRemoveItem} onDrop={this.onDrop} images={this.state.images} errorUpload={this.state.errorUpload} handleDeleteImage={this.handleDeleteImage} origin={this.state.form.origin} />
                  </div>
                  
                </div>
              </div>
              {this.state.formStatus === 'confirmation' && <p style={{ textAlign: 'center', marginBottom: '20px' }}>*You have read, understood, and agree to our <Link to="/buy-for-me-terms-of-service" target="blank">Terms of Service</Link>.</p>} */}
            </div>
          }
          {/* <div className='flex-center'>
            {this.renderButtons()}
          </div> */}
        </div>
        <TNCModal show={this.state.showModal} close={this.handleCloseModal} continue={this.handleContinue} modalClosed={this.state.closedModal}/>
      </div>
    )
  }
})

export default BuyForMe;


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/index.js
 **/